__turbopack_context__.v({
  "actions": "QPDNXq_actions",
  "bookNowButton": "QPDNXq_bookNowButton",
  "description": "QPDNXq_description",
  "learnMoreButton": "QPDNXq_learnMoreButton",
  "list": "QPDNXq_list",
  "rightCol": "QPDNXq_rightCol",
  "row": "QPDNXq_row",
  "rowInner": "QPDNXq_rowInner",
  "sectionHeader": "QPDNXq_sectionHeader",
  "sectionRoot": "QPDNXq_sectionRoot",
  "shell": "QPDNXq_shell",
  "themedBodyText": "QPDNXq_themedBodyText",
  "themedSectionHeading": "QPDNXq_themedSectionHeading",
  "themedSectionLabel": "QPDNXq_themedSectionLabel",
  "title": "QPDNXq_title",
  "titleCol": "QPDNXq_titleCol",
  "treatmentImage": "QPDNXq_treatmentImage",
  "treatmentImageShell": "QPDNXq_treatmentImageShell",
});
